{
  "de": {
    "project": {
      "actions": {
        "activate": "Aktivieren",
        "addProjectMaintainer": "Projektbetreuer hinzufügen",
        "add_as_partner": "Als Partner hinzufügen",
        "add_as_partner_description": "Sind Sie sicher, dass Sie {partner} als Partner zu diesem Projekt hinzufügen möchten?",
        "add_project_partner": "Projektpartner hinzufügen",
        "additional_information": "Zusätzliche Informationen",
        "changeProjectLogin": "Projektbild ändern",
        "changeProjectLogo": "Projektlogo ändern",
        "deactivate": "Deaktivieren",
        "edit": "Bearbeiten",
        "finishRequest": "Anfrage senden",
        "follow": "Folgen",
        "giveAccess": "Zugriff gewähren",
        "maintainerAdd": "Projektbetreuer hinzufügen",
        "maintainerAddDescription": "Sind Sie sicher, dass Sie {maintainer} Zugriff auf dieses Projekt gewähren möchten?",
        "maintainerRemove": "Projektbetreuer entfernen",
        "maintainerRemoveDescription": "Sind Sie sicher, dass Sie den Zugriff auf dieses Projekt für {maintainer} entziehen möchten?",
        "new": "Projekt",
        "next": "Weiter",
        "remove_partner": "{partner} entfernen",
        "remove_project_partner": "Projektpartner entfernen",
        "remove_project_partner_description": "Sind Sie sicher, dass Sie {partner} aus den Projektpartnern entfernen möchten?",
        "selectOption": "Option auswählen",
        "selectTemplate": "Vorlage auswählen",
        "submit": "Projekt erstellen",
        "unFollow": "Nicht mehr folgen"
      },
      "attributes": {
        "address": "Adresse",
        "currency": "Währung",
        "delivery_date_actual": "Voraussichtliches Enddatum",
        "delivery_date_contractual": "Vertragliches Enddatum",
        "description": "Beschreibung",
        "internal_note": "Interne Notiz zum Projekt",
        "measurement": "Maßeinheit",
        "name": "Name",
        "picture_login_url": "Projektbild",
        "picture_logo_url": "Projektlogo",
        "quotity_total": "Gesamter Übertragungsbetrag",
        "skip_building": "Gebäude ausblenden",
        "skip_lot": "Grundstück ausblenden",
        "skip_phase": "Phase ausblenden",
        "skip_unit": "Einheit ausblenden (Projekt mit einer Einheit)",
        "start_date": "Startdatum",
        "units_count": "Anzahl erstellter Einheiten",
        "units_count_max": "Maximale Anzahl an Einheiten",
        "vat_percentage": "MwSt. %",
        "website_url": "Website-URL"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Kapazität erreicht, bitte setzen Sie sich mit uns in Verbindung."
        }
      },
      "import": {
        "add": "+ Hinzufügen",
        "add_instead": "Ich möchte eigentlich {levels} hinzufügen",
        "building": "Gebäude",
        "buildings": "Gebäude",
        "changed_mind": "Diese Ebene überspringen",
        "create_new": "Wie lautet der Name von {type}",
        "download_template": "Importvorlage herunterladen",
        "drop_or_upload": "Vorlage hier ablegen oder klicken zum Hochladen",
        "error_line": "Fehler in Zeile",
        "file_unreadable": "Diese Datei konnte nicht gelesen werden. Stellen Sie sicher, dass es sich um eine gültige Tabelle handelt, und versuchen Sie es erneut",
        "fill_space_info": "Vorlage mit Informationen zu Nebenflächen ausfüllen",
        "fill_unit_info": "Vorlage mit Informationen zu Einheiten ausfüllen",
        "fix_file_upload": "Bitte beheben Sie die Probleme und laden Sie die Datei erneut hoch.</br>Bestehende Einheiten werden nicht entfernt, aber aktualisiert, wenn sich seit dem letzten Upload etwas in der Datei für diese Einheit geändert hat.",
        "fix_file_upload_space": "Bitte beheben Sie die Probleme und laden Sie die Datei erneut hoch.</br>Bestehende Nebenflächen werden nicht entfernt, aber aktualisiert, wenn sich seit dem letzten Upload etwas in der Datei für diese Nebenfläche geändert hat.",
        "for": "für",
        "import_column_title": "Möchten Sie {column_type} hinzufügen?",
        "import_partial_success": "Import teilweise erfolgreich. Nachfolgend die verbleibenden Fehler:",
        "import_spaces": "Nebenflächen importieren",
        "import_units": "Einheiten importieren für",
        "lot": "Grundstück",
        "lots": "Grundstücke",
        "no": "nein",
        "noLevels": "Keine {levels}",
        "phase": "Phase",
        "phases": "Phasen",
        "plot": "Grundstück",
        "select_level_above": "Wählen Sie {level} aus, um fortzufahren",
        "start_upload": "Upload starten",
        "step": "Schritt",
        "unit_info": "Sie können Einheiten importieren, sobald das Projekt erstellt wurde",
        "unit_limit": "Sie möchten mehr Einheiten importieren, als Ihnen erlaubt sind. Bitte entfernen Sie {exceeded_by} Einheit(en) oder bitten Sie uns, Ihre zulässige Anzahl an Einheiten zu erhöhen",
        "units": "Einheiten",
        "upload_filled_template": "Ausgefüllte Vorlage hochladen",
        "upload_new_file": "Neue Datei hochladen",
        "upload_spaces": "Nebenflächen hochladen",
        "upload_units": "Einheiten hochladen",
        "uploaded_file": "Hochgeladene Datei",
        "validations_failed": "Einige Validierungen sind fehlgeschlagen",
        "yes": "ja"
      },
      "labels": {
        "activate": "Projekt aktivieren",
        "checkLevels": "Wählen Sie die Ebenen aus, die Sie hinzufügen möchten:",
        "companyInfo": "Informationen zur Organisation",
        "companyNameTitle": "Organisationsname",
        "congratulationsNewProject": "Herzlichen Glückwunsch zu Ihrem neuen Projekt",
        "copyFromTemplate": "Aus Vorlagenprojekt kopieren (optional)",
        "customer_can_create_issue": "Kunde kann Punkt erstellen",
        "customersCanLogIn": "Kunden für dieses Projekt können sich anmelden mit",
        "deactivate": "Projekt deaktivieren",
        "deactivated": "Deaktiviert",
        "deactivatedProjects": "Deaktivierte Projekte",
        "download_export": "Meinen Export herunterladen",
        "downloading_export": "Wird heruntergeladen",
        "endsOn": "Endet am {enddate}",
        "export_expiration": "Ihre Exportdaten stehen zum Download bereit. Sie bleiben bis {time} verfügbar.",
        "export_explanation": "Fordern Sie einen Export all Ihrer Daten an, einschließlich Konversationen und Dokumente.",
        "export_failed": "Export fehlgeschlagen",
        "export_file": "Meine Datei exportieren",
        "export_notification_snack": "Das Zusammenstellen Ihrer Datei kann einige Minuten dauern. Sie erhalten eine Benachrichtigung, sobald sie zum Download bereitsteht.",
        "export_prepared": "Ihre Exportdaten stehen in Kürze zum Download bereit.",
        "export_preparing": "Export wird vorbereitet",
        "filterProject": "Projekt auswählen",
        "finalSteps": "Letzte Schritte",
        "follow": "Folgen Sie {project}, um Benachrichtigungen zu erhalten.",
        "followedProjects": "Meine Projekte",
        "following": "Folgt",
        "general": "Allgemein",
        "importContacts": "Ja, ich möchte Kundenkontakte importieren",
        "importInformationSubtitle": "Anstatt Nebenflächen und Kontakte einzeln hinzuzufügen, können wir Ihnen beim Importieren einer CSV-Datei helfen. Aktivieren Sie die Kontrollkästchen unten, und ein Ziggu-Teammitglied wird sich mit Ihnen in Verbindung setzen.",
        "importInformationTitle": "Informationen importieren?",
        "importSpaces": "Ja, ich möchte Stellplätze und Abstellräume importieren",
        "importUnits": "Ja, ich möchte Einheiten und deren Informationen importieren",
        "included": "Enthalten",
        "internal": "Intern",
        "invoice_subtitle": "Wir stellen nur dann eine Rechnung aus, wenn dies erforderlich ist, z. B. wenn in Ihrem Paket keine Einheiten mehr übrig sind.",
        "invoice_title": "An welche E-Mail-Adresse können wir unsere Rechnungen senden?",
        "isTemplateProject": "Dies ist ein Vorlagenprojekt",
        "levelBuildingExplainer": "Wählen Sie dies, wenn Sie mehrere Einheiten in einem oder mehreren Gebäuden haben.",
        "levelPhaseExplainer": "Wählen Sie dies, wenn Ihr Projekt in verschiedenen, zeitlich versetzten Phasen gebaut wird.",
        "levelPlotExplainer": "Wählen Sie dies, wenn Ihr Projekt aus mehreren Grundstücken besteht.",
        "levelProjectExplainer": "Ihr Projekt ist der größte Baustein und unverzichtbar für den Start.",
        "levelUnitExplainer": "Die Einheit ist der kleinste Baustein. Das ist das Haus oder die Wohnung, die Sie für Ihre Kunden bauen.",
        "levels": "Projektstruktur",
        "limitReached": "Projektlimit erreicht",
        "nameTitle": "Der Name des Projekts?",
        "newProjectTitle": "Erstellen wir Ihr neues Projekt!",
        "noAccess": "Sie haben keinen Zugriff auf dieses Projekt",
        "noFollowedProjects": "Klicken Sie auf das Benachrichtigungssymbol, um einem Projekt zu folgen.",
        "noProjects": "Keine Projekte gefunden",
        "optional_information": "Optionale Informationen",
        "optional_information_subtitle": "Gibt es noch etwas, das Sie uns mitteilen möchten?",
        "otherProjects": "Andere Projekte",
        "outOfProjects": "Es sieht so aus, als hätte Ihr Paket keine aktiven Projekte mehr übrig.",
        "outOfProjectsContact": "Kontaktieren Sie Ziggu, um Ihr Paket zu erweitern und weiterhin Projekte zu erstellen.",
        "partner_invitation_notice": "{partner} wurde noch nicht eingeladen. Eine Einladung wird gesendet, sobald {partner} zu den Projektpartnern hinzugefügt wird.",
        "pendingProjects": "{first_project_name} wurde angefragt und wird derzeit von Ziggu eingerichtet | {count} Projekte wurden angefragt und werden derzeit von Ziggu eingerichtet",
        "permission_partner_project": "Ein Partner, mit dem Sie einfach Dokumente und Angebote teilen können",
        "permissionsOwnerOnly": "Nur Teammitglieder mit der Rolle Inhaber können neue Projektbetreuer hinzufügen",
        "permissionsRoleMaintainer": "Ein Teammitglied mit Zugriff auf dieses Projekt",
        "project": "Projekt {project}",
        "projectBranding": "Projekt-Branding",
        "projectIsDeactivated": "Dieses Projekt ist deaktiviert",
        "projectMaintainers": "Projektbetreuer",
        "projectName": "Projektname",
        "projectStructure": "Projektstruktur",
        "projectStructureSubtitle": "Sie haben jetzt die Möglichkeit, 3 zusätzliche Ebenen hinzuzufügen, um Ihre Einheiten besser zu organisieren.</br>Gehen wir sie Schritt für Schritt gemeinsam durch.",
        "projectStructureSubtitleOld": "Die Projektstruktur wird einmalig zu Beginn des Projekts festgelegt",
        "project_label": "Projekt",
        "project_partners": "Projektpartner",
        "projects": "Projekte",
        "remove_project_partner_prohibited": "{partner} ist Entscheidungen in diesem Projekt zugeordnet und kann nicht aus den Projektpartnern entfernt werden.",
        "remove_project_partner_prohibited_label": "Projektpartner kann nicht entfernt werden",
        "searchProject": "Projekt suchen",
        "searchProjects": "Projekt suchen",
        "selectATemplateProject": "Vorlagenprojekt auswählen",
        "selected": "Ausgewählt",
        "showProject": "Projekt anzeigen",
        "spaces": "Nebenflächen",
        "startsOn": "Beginnt am {startdate}",
        "step1Info": "Gehen wir gemeinsam einige Details durch, um loszulegen.",
        "step1Title": "Herzlichen Glückwunsch zu Ihrem neuen Projekt!",
        "step2Info": "An welche Organisation können wir die Rechnung adressieren?",
        "step2Title": "Rechnungsdetails",
        "step3Title": "Zwischenebenen erforderlich?",
        "step4Info": "Wie geht es weiter? Ziggu richtet {project} innerhalb von 3 bis 5 Arbeitstagen ein. Sie werden benachrichtigt, sobald alles bereit ist.",
        "templateProjects": "Vorlagenprojekte",
        "unFollow": "Keine Benachrichtigungen mehr für {project} erhalten.",
        "underConstruction": "Im Bau",
        "units": "Einheiten",
        "unitsActiveRemaining": "VERFÜGBARE EINHEITEN",
        "unitsAllotted": "ZUGETEILTE EINHEITEN",
        "unitsCountSubtitle": "Wie viele Einheiten?",
        "unselected": "Zum Auswählen klicken",
        "youAreEditingTemplateProject": "Sie bearbeiten ein Vorlagenprojekt",
        "you_have_inbound_emails": "Sie haben 1 unbearbeitete eingehende E-Mail | Sie haben {number} unbearbeitete eingehende E-Mails"
      },
      "messages": {
        "units_count_max": "Wenn Sie weitere Einheiten erstellen möchten, kontaktieren Sie uns bitte über die Chat-Schaltfläche."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Richten wir Ihr neues Projekt ein!"
          },
          "step_3": {
            "subtitle": "Klicken Sie auf die Karten, um die Zwischenebenen zu aktivieren.",
            "title": "Zwischenebenen benötigt?"
          },
          "step_4": {
            "info": "Entscheidungs- und Umfragevorlagen können importiert werden, sobald die Einheiten für dieses Projekt erstellt wurden.",
            "placeholder": "Wählen Sie ein Projekt aus, oder lassen Sie dieses Feld leer, wenn Sie nicht aus einer Vorlage kopieren möchten",
            "title": "Vorlage als Basis verwenden?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Zurück zu den Projekten"
      },
      "notifications": {
        "emailHasBeenCopied": "E-Mail-Adresse kopiert",
        "pictureChangedSuccessfully": "Das Bild wurde aktualisiert. Es kann bis zu einer Stunde dauern, bis die Änderungen sichtbar sind.",
        "tokenCopied": "Token erfolgreich kopiert",
        "urlHasBeenCopied": "URL erfolgreich kopiert"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Sie haben keinen Zugriff auf Projekte. Bitten Sie ein Teammitglied mit der Rolle Inhaber, Ihnen Zugriff zu gewähren.",
            "title": "Keine Projekte"
          }
        },
        "partners": {
          "noProjectSubtitle": "Sie werden benachrichtigt, sobald Ihnen ein neues Projekt zugewiesen wird",
          "noProjectTitle": "Noch kein Projekt"
        }
      },
      "snackbars": {
        "duplicate": "Der Kopiervorgang wurde gestartet und kann einen Moment dauern. Bitte aktualisieren Sie die Seite nach ein paar Minuten."
      },
      "sort": {
        "nameAsc": "Name A → Z",
        "nameDesc": "Name Z → A",
        "newest": "Neueste zuerst",
        "oldest": "Älteste zuerst"
      },
      "toasts": {
        "activateSuccess": "{project_name} wurde erfolgreich aktiviert.",
        "deactivateSuccess": "{project_name} wurde erfolgreich deaktiviert.",
        "duplicate": "Das Projekt wurde erstellt, aber das Kopieren der Vorlage kann einige Minuten dauern."
      },
      "tooltip": {
        "hasNoActiveUnits": "Hat keine aktiven Einheiten",
        "turnOffNotifications": "Benachrichtigungen für {project} ausschalten",
        "turnOnNotifications": "Benachrichtigungen für {project} einschalten"
      },
      "validation": {
        "addressInformationRequired": "Adressinformationen erforderlich",
        "companyNeedName": "Organisationsname erforderlich",
        "companyNeedVatNumber": "USt-IdNr. erforderlich",
        "dateAfter": "Datum muss nach dem Startdatum liegen",
        "lessThanOrEqual": "Die Zahl muss kleiner oder gleich {max_number} sein",
        "maxLength": "Der Name darf maximal {length} Zeichen lang sein",
        "nameAlreadyTaken": "Der Name wird für dieses Projekt bereits verwendet",
        "needName": "Titel erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 850)",
        "needUnitsCount": "Anzahl der Einheiten ist erforderlich"
      }
    }
  }
}
